const styleMap = {
  RED: { color: "#a00" },
  LINK: { color: "#3b5998", textDecoration: "underline" }
};

export default styleMap;
